// extracted by mini-css-extract-plugin
export default {"previewAuto":"InfoPage_previewAuto__wT6pX","innerWrap":"InfoPage_innerWrap__wh6up"};